import React from 'react'

const RatingNumber = ({ number, handleOnClick, selectedNumber, type }) => {
    return (
        <div className={`flex dark:text-white justify-center items-center rounded-full hover:bg-gray-600 hover:text-gray-100 w-[35px] h-[35px] text-center cursor-pointer ${selectedNumber === number && 'bg-gray-700'}`} onClick={(e) => handleOnClick(e, type)}>
            <span className="text-xs sm:text-xl text-gray-400">{number}</span>
        </div>
    )
}

export default RatingNumber